import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ConstantsService {
    TZ_IST = 'Asia/Kolkata';
    DATE_FORMAT: string = 'DD-MM-YYYY';
    DATETIME_FORMAT: string = 'MM-DD-YYYY hh:mm A';
    DATETIME_FORMAT_USER: string = 'DD-MM-YYYY hh:mm A';

    constructor() {
    }

    unsubscribe(subscriptions: any[]) {
        for (const sub of subscriptions) sub.unsubscribe();
    }

    user = {
        removePermanentConfirm: '<p class="dialog-text">Do you want to <b class="text-danger">permanently remove user</b>?<br/>It will <b class="text-danger">remove all data of that user</b> like user was never exist.</p>',
        removePermanentSecondConfirm: '<p class="dialog-text">Confirm <b class="text-danger">remove user</b>?</p>',
        removePermanent: 'User permanently removed.',
        removePermanentError: 'Permanently user removal operation failed.',
        addSuccess: 'User added successfully.',
        editSuccess: 'User edited successfully.',
        addressRemovePermanent: 'Permanently address removed.',
        sendSMS: 'OTP sent to your mobile number.',
        sendMail: 'OTP sent to your email.',
        pinVerified: 'Pin is verified!',
        pinIncorrect: 'The PIN is incorrect!',
    };

    order = {
        orderSuccess: 'Your order is confirmed!',
    };

    applyCode = {
        appliedCode: 'Coupon Code Already Applied!',
        success: 'Congrats! Coupon code applied successfully.',
        invalidCode: 'Invalid Code! This product cannot be applied.'
    };

    review = {
        success: 'Thanks — your review has been submitted.',
    };

    addToCart = {
        success: 'Product added to cart successfully!',
        remove: 'Product removed from cart successfully!',
    };

    wishlist = {
        success: 'Product added to your wishlist successfully!',
        remove: 'Product removed from your wishlist successfully!',
    };
}
